<template>
  <div class="open-deur">
    <transition name="fade" mode="out-in" :appear="true">
      <pick-question v-if="state === 0"></pick-question>
      <play-video
        v-else-if="state === 1"
        :infoText="activeQuestion.question"
        :youtubeId="activeQuestion.video.youtubeId"
        :start="activeQuestion.video.start"
        :end="activeQuestion.video.end"
      >
      </play-video>
      <play-screen v-else-if="state === 2"></play-screen>
    </transition>
  </div>
</template>

<script>
import PickQuestion from './pickQuestion';
import PlayVideo from '@/components/elements/playVideo';
import PlayScreen from './playScreen';

export default {
  name: 'open-deur',
  components: { PickQuestion, PlayVideo, PlayScreen },
  computed: {
    state() {
      return this.$store.state.rounds.openDeur.state;
    },
    activeQuestion() {
      return this.$store.getters['openDeur/activeQuestion'];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
